import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getMe } from "@/lib/api";

export default function DailyEntryPage() {
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      try {
        await getMe();
        navigate("/game", { replace: true, state: { autoDaily: true } });
      } catch (_e) {
        navigate("/demo", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="font-display text-2xl uppercase text-center">
        Cargando reto del día...
      </div>
    </div>
  );
}
